/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */

export const STR_PROMISE = "Promise";
export const DONE = "done";
export const VALUE = "value";
export const ITERATOR = "iterator";
export const RETURN = "return";
export const REJECTED = "rejected";